import PropTypes from 'prop-types';
import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import ModalDlg from 'components/Basic/ModalDlg';
import { ArrowForward } from '@material-ui/icons';

const UserIsNotFoundModal = ({ isOpenModal, onClose }) => {
  return (
    <ModalDlg className="save_as_draft_modal" visible={isOpenModal} width={434} handleCancel={onClose} isCenter>
      <div className="header">
        <h3>
          <FormattedMessage id="The phone number is not found" />
        </h3>
      </div>
      <div className="footer">
        <div className="btn_wrapper">
          <Button className="save_button" onClick={onClose}>
            <FormattedMessage id="Close" />
            <ArrowForward className="arrow_icon" />
          </Button>
        </div>
      </div>
    </ModalDlg>
  );
};

UserIsNotFoundModal.defaultProps = {
  isOpenModal: false,
};

export default UserIsNotFoundModal;
